import * as keyboard from './keyboard.js';
import { degToRad } from './utils.js';
import { positionListener, orientListener } from './audio/panner.js';
import { touch } from './touch-joystick.js';
import * as scene from './scene.js';

export {
    direction,
    position,
    config,
    update,
    contactingBounds,
    setDirection,
}

let direction = 0; // Degrees with 0 facing north, -Y on canvas
const position = {
    x: 0,
    y: 0,
    z: 1.8,
};
const config = {
    maxVelocity: 2.5, // m/s
    acceleration: 4, // m/s^2
    damping: 4,
    controllable: true, // TODO: instead of cutting control to player, freeze its movement ?
};

const velocity = {
    x: 0,
    y: 0,
    z: 0,
    magnitude: 0,
    direction: 0, // Radians
};

let accelerateX, accelerateY;
let contactingBounds = false;

function update(dt) {
    accelerateX = 0;
    accelerateY = 0;

    if (config.controllable) {
        // Update player direction (Arrow Keys)
        if (keyboard.keyDown('ArrowLeft')) direction -= 1;
        if (keyboard.keyDown('ArrowRight')) direction += 1;
        direction %= 360;

        // Update player velocity (Arrow Keys)
        if (keyboard.keyDown('ArrowUp')) {
            accelerateY = -1;
        }
        if (keyboard.keyDown('ArrowDown')) {
            accelerateY = 1;
        }

        // Update player direction (Mouse Y)
        // TODO: Implement mouse movement

        // Update player velocity (WASD)
        if (keyboard.keyDown('w')) {
            accelerateY = -1;
        }
        if (keyboard.keyDown('a')) {
            accelerateX = -1;
        }
        if (keyboard.keyDown('s')) {
            accelerateY = 1;
        }
        if (keyboard.keyDown('d')) {
            accelerateX = 1;
        }

        // Update player direction (Gamepad)
        // TODO: Implement gamepad movement

        // Update player velocity and rotation (Touch)
        if (touch.active) {
            accelerateY = touch.yAxis;
            direction += touch.xAxis;
        }
    };

    applyAcceleration(dt);
    applyVelocity(dt);

    // Update audio listener position
    positionListener(position.x, position.z, position.y);

    // Update audio listener orientation
    orientListener(direction);
}


function applyAcceleration(dt) {
    const accelerationDirection = Math.atan2(accelerateY, accelerateX) + degToRad(direction);

    // Apply acceleration
    if (accelerateY || accelerateX) {
        velocity.x += Math.cos(accelerationDirection) * config.acceleration * 2 * dt;
        velocity.y += Math.sin(accelerationDirection) * config.acceleration * 2 * dt;
    }
}

function applyVelocity(dt) {
    // Calculate velocity magnitude
    velocity.magnitude = Math.sqrt(velocity.x**2 + velocity.y**2);

    // Calculate velocity direction
    velocity.direction = Math.atan2(velocity.y, velocity.x);

    // Limit velocity
    if (velocity.magnitude > config.maxVelocity) {
        velocity.x = Math.cos(velocity.direction) * config.maxVelocity;
        velocity.y = Math.sin(velocity.direction) * config.maxVelocity;
        velocity.magnitude = config.maxVelocity;
    }

    // Decelerate
    velocity.magnitude -= config.damping * dt;
    if (velocity.magnitude < 0) velocity.magnitude = 0;
    velocity.x = Math.cos(velocity.direction) * velocity.magnitude;
    velocity.y = Math.sin(velocity.direction) * velocity.magnitude;

    // Add velocity to position
    position.x += velocity.x * dt;
    position.y += velocity.y * dt;
    position.z += velocity.z * dt;

    // Constraint position to the worlds bounds
    const margin = 0.2;
    position.x = Math.max(
        scene.config.worldBounds.left + margin,
        Math.min(position.x, scene.config.worldBounds.right - margin)
    );
    position.y = Math.max(
        scene.config.worldBounds.top + margin,
        Math.min(position.y, scene.config.worldBounds.bottom - margin)
    );

    contactingBounds = (
        position.x === scene.config.worldBounds.left + margin ||
        position.x === scene.config.worldBounds.right - margin ||
        position.y === scene.config.worldBounds.top + margin ||
        position.y === scene.config.worldBounds.bottom - margin
    );
}

function setDirection(dir) {
    direction = dir;
}